import { Background } from '../components/Background';
import { ThemeProvider } from '../context/ThemeContext';
import { Navbar } from '../components/landing/Navbar';
import { HeroSection } from '../components/landing/HeroSection';
import { AboutSection } from '../components/landing/AboutSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { CTASection } from '../components/landing/CTASection';
import { ContactSection } from '../components/landing/ContactSection';
import { Footer } from '../components/landing/Footer';
import { ThemeSwitcher } from '../components/ThemeSwitcher';
import { usePageSEO } from '../hooks/usePageSEO';

const LandingPage = () => {
  usePageSEO('home', 'Strona Główna');

  return (
    <div className="min-h-screen relative font-sans selection:bg-primary/30 selection:text-text-main overflow-x-hidden">
      <Background />
      <Navbar />
      <ThemeSwitcher />

      <main className="snap-y snap-mandatory h-screen overflow-y-auto overflow-x-hidden scroll-smooth">
        <div className="snap-start">
          <HeroSection />
        </div>
        <div className="snap-start">
          <AboutSection />
        </div>
        <div className="snap-start">
          <TestimonialsSection />
        </div>
        <div className="snap-start">
          <CTASection />
        </div>
        <div className="snap-start">
          <ContactSection />
        </div>
        <div className="snap-start">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
